import React from 'react';

import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import {
  Button,
  Card,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Detail from './Detail';
import History from './History';
import { PrivateBlogController, init } from './privateBlogController';
import * as selectors from './selector';

import type { ContentJson } from '@/types/domain/privateBlog/entities/contentEntity';
import type { PrivateBlogCategoryJson } from '@/types/domain/privateBlog/entities/privateBlogCategoryEntity';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';

import CardMediaImage from '@/components/CardMediaImage';
import Title from '@/components/Title';

const PrivateBlog: React.FC = () => {
  const dispatch = useDispatch();
  const [
    detailPrivateBlogJson,
    setDetailPrivateBlogJson,
  ] = React.useState<PrivateBlogJson | undefined>(undefined);
  const [
    historyCategory,
    setHistoryCategory,
  ] = React.useState<PrivateBlogCategoryJson | undefined>(undefined);
  const [innerWidth, setInnerWidth] = React.useState<number>(window.innerWidth);
  React.useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const div = Math.floor(innerWidth / 280);
  const width = Math.round((innerWidth - 60 - div * 8) / div);
  const nurseryId = useSelector(selectors.nurseryIdSelector);
  const isInitCategoryItems = useSelector(selectors.isInitCategoryItemsSelector);
  const categoryList = useSelector(selectors.categoryListSelector);
  const categoryItems = useSelector(selectors.categoryItemsSelector);
  const content: ContentJson | undefined = useSelector(selectors.contentSelector);
  React.useEffect(
    () => init(dispatch, nurseryId, isInitCategoryItems),
    [dispatch, nurseryId, isInitCategoryItems],
  );
  if (!nurseryId) {
    return (
      <div>
        <Title title="園内ブログ" />
        <div style={{ marginTop: '10px' }}>
          表示する施設がありません。
        </div>
      </div>
    );
  }
  if (categoryList.length === 0 || !categoryItems) {
    return (
      <div>
        <Title title="園内ブログ" />
        <div style={{ marginTop: '10px' }}>
          準備中です...
        </div>
      </div>
    );
  }
  const controller = new PrivateBlogController(dispatch, nurseryId, categoryList, categoryItems);
  const categories = controller.getCategories();
  const actionDetail = controller.getActionDetail(setDetailPrivateBlogJson);
  const detailCategory = categories.find((v) => v.categoryId === detailPrivateBlogJson?.categoryId);
  const contents = [];
  for (let i = 0; i < categories.length; i += 1) {
    const data = categories[i];
    const items = controller.getPages(data);
    const content = [];
    if (items.length > 0) {
      const item = items[0];
      content.push(
        <div key={`${i}-0`}>
          <ListItem>
            <ImageList cols={div}>
              <ImageListItem
                key={item.publishDatetime}
                style={{
                  width,
                  border: 'solid 1px #000',
                  backgroundColor: '#aaa',
                }}
              >
                <Card style={{ margin: 'auto' }}>
                  <CardMediaImage
                    nurseryId={nurseryId}
                    s3Path={item.s3ThumbnailPath}
                    width={width}
                    onClick={() => actionDetail(item)}
                    alt="NoImage"
                    objectFit="cover"
                  />
                </Card>
                <ImageListItemBar
                  subtitle={item.title}
                />
              </ImageListItem>
            </ImageList>
          </ListItem>
          <ListItem>
            <ListItemText primary={item.abstract} />
          </ListItem>
        </div>,
      );
    } else {
      content.push(
        <div key={`${i}-0`}>
          <ListItem>
            <ListItemText primary="最新記事なし" />
          </ListItem>
        </div>,
      );
    }
    contents.push(
      <div key={`category${i}`} style={{ marginTop: '10px' }}>
        <ListItem
          sx={{ bgcolor: 'select' }}
        >
          <ListItemIcon>
            <HistoryEduIcon />
          </ListItemIcon>
          <ListItemText primary={data.category} />
        </ListItem>
        <Divider />
        <List component="div" disablePadding>
          {content}
          <ListItem>
            <ListItemText primary="" />
            <Button
              onClick={() => setHistoryCategory(data)}
            >
              過去の記事
            </Button>
          </ListItem>
        </List>
      </div>,
    );
  }
  return (
    <div>
      <Title title="園内ブログ" />
      <div>
        <List>
          {contents}
        </List>
      </div>
      {historyCategory && (
        <History category={historyCategory} close={() => setHistoryCategory(undefined)} />
      )}
      {detailPrivateBlogJson && content && detailCategory && (
        <Detail
          privateBlog={detailPrivateBlogJson}
          content={content}
          category={detailCategory.category}
          publishDate={detailPrivateBlogJson.publishDatetime}
          close={() => actionDetail(undefined)}
        />
      )}
    </div>
  );
};

export default PrivateBlog;
